export default {
      id: "reefer-loading-usage",
      viewBox: "0 0 108 110",
      url: __webpack_public_path__ + "img/icons.svg#reefer-loading",
      toString: function () {
        return this.url;
      }
    }